import types from '../actions/types'
import errorHelper from '../helpers/error.helper'

const initialState = {}

export default function (state = initialState, action) {
  switch (action.type) {
    case `${types.CHECK_NEED_REGISTER}_PENDING`:
      return { ...state, skipRegister: false }
    case `${types.CHECK_NEED_REGISTER}_FULFILLED`:
      return { ...state, skipRegister: action.payload.data.skipRegister || false, error: null }
    case `${types.CHECK_NEED_REGISTER}_REJECTED`:
      return { ...state, skipRegister: false, error: action.payload.response ? action.payload.response.data : {} }

    case `${types.REGISTER_USER}_PENDING`:
      return { ...state, user: null }
    case `${types.REGISTER_USER}_FULFILLED`:
      return { ...state, user: action.payload.data, error: null }
    case `${types.REGISTER_USER}_REJECTED`:
      return { ...state, error: action.payload.response.data, user: null }

    case `${types.AUTHENTICATE_USER}_PENDING`:
      return { ...state, user: null, isProcessing: true }
    case `${types.AUTHENTICATE_USER}_FULFILLED`:
      return { ...state, user: action.payload.data, isProcessing: false, error: null, authSucceeded: true, needVerify: !action.payload.data.is_verified }
    case `${types.AUTHENTICATE_USER}_REJECTED`:
      return { ...state, error: action.payload.response ? action.payload.response.data : action.payload.message, isProcessing: false, user: null }

    case types.SET_NEED_VERIFY:
      return { ...state, needVerify: action.data }

    case `${types.VERIFY_MAGIC_CODE}_PENDING`:
      return { ...state, user: null, isProcessing: true }
    case `${types.VERIFY_MAGIC_CODE}_FULFILLED`:
      return { ...state, user: action.payload.data, isProcessing: false, error: null }
    case `${types.VERIFY_MAGIC_CODE}_REJECTED`:
      return { ...state, error: action.payload.response.data, isProcessing: false, user: null }

    case `${types.VERIFY_SEND_TOKEN}_PENDING`:
      return { ...state }
    case `${types.VERIFY_SEND_TOKEN}_FULFILLED`:
      return { ...state, siteApplication: action.payload.data.siteApplication, token: action.payload.data.token, error: null }
    case `${types.VERIFY_SEND_TOKEN}_REJECTED`:
      return { ...state, error: action.payload.response.data, response: action.payload.response, isProcessing: false, user: null }

    case `${types.GET_LOGIN_PROVIDER_INFO}_PENDING`:
      return { ...state, user: null, isCheckingServiceProvider: true }
    case `${types.GET_LOGIN_PROVIDER_INFO}_FULFILLED`:
      return { ...state, provider: action.payload.data, error: null, isCheckingServiceProvider: false }
    case `${types.GET_LOGIN_PROVIDER_INFO}_REJECTED`:
      return { ...state, error: errorHelper.buildErrors(action.payload.response.data.errors), provider: null, isCheckingServiceProvider: false }

    case `${types.CHECK_LOGGEDIN}_PENDING`:
      return { ...state, user: null }
    case `${types.CHECK_LOGGEDIN}_FULFILLED`:
      return { ...state, user: action.payload.data, error: null }
    case `${types.CHECK_LOGGEDIN}_REJECTED`:
      return { ...state, error: action.payload.response.data, user: null }

    case `${types.UPDATE_USER_PROFILE}_PENDING`:
      return { ...state, updating: true }
    case `${types.UPDATE_USER_PROFILE}_FULFILLED`:
      return { ...state, user: action.payload.data, updating: false, updated: true, error: null }
    case `${types.UPDATE_USER_PROFILE}_REJECTED`:
      return { ...state, error: action.payload.response.data, updating: false, updated: false }

    /* Update user password */
    case `${types.UPDATE_USER_PASSWORD}_PENDING`:
      return { ...state, isProcessing: true, errors: {} }
    case `${types.UPDATE_USER_PASSWORD}_FULFILLED`:
      return { ...state, isProcessing: false, errors: {}, isSaved: true }
    case `${types.UPDATE_USER_PASSWORD}_REJECTED`:
      return { ...state, errors: errorHelper.buildErrors(action.payload.response.data.errors), isProcessing: false, isSaved: false }

    /* Update user avatar */
    case `${types.UPDATE_USER_AVATAR}_PENDING`:
      return { ...state, isProcessing: true, errors: {} }
    case `${types.UPDATE_USER_AVATAR}_FULFILLED`:
      return { ...state, isProcessing: false, isDialogOpen: false, errors: {}, im: null, image: null, isSaved: true, avatarDeleted: false, avatarUpdated: true }
    case `${types.UPDATE_USER_AVATAR}_REJECTED`:
      return !action.payload.response || !action.payload.response.data.response
        ? { ...state, errors: 'Image too big', isProcessing: false, isSaved: false }
        : { ...state, errors: errorHelper.buildErrors(action.payload.response.data.errors), isProcessing: false, isSaved: false }

    /* Delte user avatar */
    case `${types.DELETE_USER_AVATAR}_PENDING`:
      return { ...state, isProcessing: true, errors: {} }
    case `${types.DELETE_USER_AVATAR}_FULFILLED`:
      return { ...state, avatarDeleted: true, isProcessing: false, isDialogOpen: false, errors: {} }

    case `${types.CHANGE_FILE}`:
      return { ...state, image: action.payload.image }

    case `${types.CHANGE_CROP}`:
      return { ...state, crop: action.payload.crop, pixelCrop: action.payload.pixelCrop }

    case `${types.LOAD_IMAGE}`:
      return { ...state, img: action.payload.img, crop: action.payload.crop }

    case `${types.LOGOUT_USER}_PENDING`:
      return { ...state, user: null, updating: true }
    case `${types.LOGOUT_USER}_FULFILLED`:
      return { ...state, user: null, updating: false, error: null }
    case `${types.LOGOUT_USER}_REJECTED`:
      return { ...state, updating: false, error: action.payload.response.data }

    /* Verify Invite token */
    case `${types.VERIFY_INVITE_TOKEN}_PENDING`:
      return { ...state, user: null, error: null }
    case `${types.VERIFY_INVITE_TOKEN}_FULFILLED`:
      return { ...state, isVerificationSuccessful: true, isProcessing: false, error: null, user: action.payload.data }
    case `${types.VERIFY_INVITE_TOKEN}_REJECTED`:
      return { ...state, isProcessing: false, isVerificationSuccessful: false, error: action.payload.response.data, user: null }

    case `${types.FORGOT_PASSWORD}_PENDING`:
      return { ...state, user: null, error: null }
    case `${types.FORGOT_PASSWORD}_FULFILLED`:
      return { ...state, isSuccessful: true, error: null, user: action.payload.data, resetEmailSent: true }
    case `${types.FORGOT_PASSWORD}_REJECTED`:
      return { ...state, isProcessing: false, isSuccessful: false, error: action.payload.response.data, user: null }

    case `${types.RESET_PASSWORD}_PENDING`:
      return { ...state, user: null, error: null }
    case `${types.RESET_PASSWORD}_FULFILLED`:
      return { ...state, isSuccessful: true, error: null, user: action.payload.data, resetEmailSent: true }
    case `${types.RESET_PASSWORD}_REJECTED`:
      return { ...state, isProcessing: false, isSuccessful: false, error: action.payload.response.data, user: null }

    /* Set initial password after token verification */
    case `${types.SET_USER_PASSWORD}_PENDING`:
      return { ...state, isProcessing: true, error: null }
    case `${types.SET_USER_PASSWORD}_FULFILLED`:
      return { ...state, isPasswordSetSuccessful: true, isProcessing: false, error: null, user: action.payload.data }
    case `${types.SET_USER_PASSWORD}_REJECTED`:
      return { ...state, isProcessing: false, isPasswordSetSuccessful: false, error: errorHelper.buildErrors(action.payload.response.data.errors) }

    case `${types.SEARCH_USERS}_PENDING`:
      return { ...state, user: null }
    case `${types.SEARCH_USERS}_FULFILLED`:
      return { ...state, errors: {}, users: action.payload.data }
    case `${types.SEARCH_USERS}_REJECTED`:
      return { ...state, error: action.payload.response.data, user: null }

    case `${types.IMPERSONATE_USER}_PENDING`:
      return { ...state, user: null }
    case `${types.IMPERSONATE_USER}_FULFILLED`:
      return { ...state, error: null }
    case `${types.IMPERSONATE_USER}_REJECTED`:
      return { ...state, error: action.payload.response.data, user: null }

    case `${types.REWELCOME}_PENDING`:
      return { ...state, user: null, error: null, isProcessing: true }
    case `${types.REWELCOME}_FULFILLED`:
      return { ...state, isSuccessful: true, isProcessing: false, error: null, user: action.payload.data, resetEmailSent: true }
    case `${types.REWELCOME}_REJECTED`:
      return { ...state, isProcessing: false, isSuccessful: false, error: action.payload.response.data, user: null }

    default:
      return state
  }
}
